import { AdSupplier } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export function useAdSupplierById(supplierId: string | undefined) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<{ success: boolean; data: AdSupplier }>(
    token && supplierId ? `/api/ad-suppliers/${supplierId}` : null,
    undefined,
    token ?? '',
  )

  return {
    adSupplier: data?.data,
    isLoading,
    isError: error,
    mutate,
  }
}
